import { debounce } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import { BiSearch } from "react-icons/bi";
import { MdKeyboardArrowDown } from "react-icons/md";
import { TfiClose } from "react-icons/tfi";
import Modal from "react-modal";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import NoResult from "../../../../components/NoResult";
import useAppAccessor from "../../../../hooks/useappAccessor";
import { callEvent } from "../../../../services/main.service";
import { saveInteractionAPI } from "../../../../services/record.service";
import { getItemTranontService } from "../../../../services/tranont.service";
import {
  setInteractionData,
  setShopComAllData,
} from "../../interaction.actions";
import { InteractionData } from "../../interaction.interface";
import SelectListBrand from "../selectListBrand";
import SelectListCategories from "../selectListCategories";
import SelectListCategoriesSub from "../selectListCategorySub";
import { payloadTranontSite } from "./constants";
import "./style.css";
import { tranont_brand } from "../../../../assets/icons";
import { getBrandTheme } from "../../../../utils/brand.util";

const siteName = "Trannont";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    height: "calc(var(--vh, 1vh) * 85)",
    width: "80%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: 0,
    border: 0,
    backgroundColor: "#000000",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    position: "absolute" as const,
  },
  overlay: {
    backgroundColor: "rgba(24, 24, 24,0.8)",
    zIndex: 99999,
    position: "fixed" as const,
  },
};

function InteractionTranont(props: any) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { getInteractions, getLiveMainData, getUserData } = useAppAccessor();
  const { interactionData, shopSiteName, shopComAllData } = getInteractions();
  const { configurationData } = getLiveMainData();
  const { joinWithAttendeeData, createStreamData, hostTime } =
    getLiveMainData();
  const { client } = getUserData();
  const { user } = getUserData();
  const { publicUserData } = user;
  const [interactionDataArray, setInteractionDataArray] = useState<
    InteractionData[]
  >([]);
  const time = Date.now();

  const [productsDetailData, setProductsDetailData] = useState([]);

  const [productsBrandTotal, setProductsBrandTotal] = useState<any>(null);
  const [productsBrandTemp, setProductsBrandTemp] = useState<any>(null);

  const [productsCategoryTotal, setProductsCategoryTotal] = useState<any>(null);
  const [productsCategoryTemp, setProductsCategoryTemp] = useState<any>(null);

  const [productsCategorySub, setProductsCategorySub] = useState<any>(null);
  const [productsCategorySubTemp, setProductsCategorySubTemp] =
    useState<any>(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [payloadShopSite, setPayloadShopSite] = useState<any>(null);
  const [count, setCount] = useState(0);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);
  const childeBrandRef = useRef<any>();
  const childeCatRef = useRef<any>();
  const childeSubCatRef = useRef<any>();
  const totalItems = useRef(0);
  const isGetMoreItem = useRef(true);

  const inputRef = useRef<HTMLInputElement>(null);

  const [isDataFetched, setIsDataFetched] = useState(false);
  const { language } = getUserData();

  const scrollPositionRef = useRef(0);
  const listContainerRef = useRef<HTMLDivElement>(null);
  const listenerAddedRef = useRef(false);
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);
  const getMoreItemRef = useRef<() => void>();
  const isMergingProductsRef = useRef(false);

  useEffect(() => {
    checkShopSite(shopSiteName);
  }, []);

  useEffect(() => {
    if (!payloadShopSite) {
      return;
    }

    const isInitialLoad = !payloadShopSite?.start || payloadShopSite.start === 0;
    if (isInitialLoad) {
      setLoading(true);
    }
    setIsDataFetched(false);

    if (
      payloadShopSite?.start !== undefined ||
      payloadShopSite?.term ||
      payloadShopSite?.term === ""
    ) {
      getItemTranontService(payloadShopSite, shopSiteName)
        .then((data: any) => {
          const item = data.data;
          totalItems.current = data.pagination.total;

          if (payloadShopSite?.start && payloadShopSite.start > 0) {
            isMergingProductsRef.current = true;
            setProductsDetailData((prevProducts: any[]) => {
              const isSameSearch = shopComAllData?.searchTerm
                ? payloadShopSite.term === shopComAllData?.searchTerm
                : true;

              if (isSameSearch && prevProducts.length > 0) {
                const newProducts = item.products || [];
                const existingIds = new Set(prevProducts.map((p: any) => p.id));
                const uniqueNewProducts = newProducts.filter(
                  (p: any) => !existingIds.has(p.id)
                );
                const mergedProducts = [...prevProducts, ...uniqueNewProducts];

                const mergedData = {
                  ...item,
                  products: mergedProducts,
                  searchTerm: payloadShopSite.term,
                };
                dispatch(setShopComAllData(mergedData));

                requestAnimationFrame(() => {
                  isMergingProductsRef.current = false;
                });

                return mergedProducts;
              }
              const newData = {
                ...item,
                searchTerm: payloadShopSite.term,
              };
              dispatch(setShopComAllData(newData));
              requestAnimationFrame(() => {
                isMergingProductsRef.current = false;
              });
              return item.products || [];
            });
          } else {
            isMergingProductsRef.current = false;
            const newData = {
              ...item,
              searchTerm: payloadShopSite?.term,
            };
            dispatch(setShopComAllData(newData));
            setProductsDetailData(item.products || []);
            isGetMoreItem.current = true;
            scrollPositionRef.current = 0;
          }

          if (payloadShopSite?.start >= totalItems.current) {
            isGetMoreItem.current = false;
          } else {
            isGetMoreItem.current = true;
          }

          setProductsCategoryTotal(item["categories"]);
          setProductsBrandTotal(getTrademarkOutput(item["brands"]));
          setLoading(false);
          setIsDataFetched(true);
        })
        .catch((err) => {
          console.log("API shop COM error:", err);
          setIsDataFetched(true);
          setLoading(false);
        });
    } else {
      setLoading(false);
      setIsDataFetched(true);
    }
  }, [payloadShopSite]);

  useEffect(() => {
    dispatch(setInteractionData(interactionDataArray));
    saveInteractionAPI(configurationData?.stream_id, interactionDataArray);
  }, [interactionDataArray]);

  useEffect(() => {
    if (interactionData.length > 0) {
      setInteractionDataArray(interactionData);
    }
  }, []);

  useEffect(() => {
    const container = listContainerRef.current;

    if (!container || listenerAddedRef.current) {
      return;
    }

    listenerAddedRef.current = true;

    const handleScroll = () => {
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 50;

      if (isNearBottom) {
        setShowScrollIndicator(false);
        if (timeoutIdRef.current) {
          clearTimeout(timeoutIdRef.current);
        }
        timeoutIdRef.current = setTimeout(() => {
          if (isGetMoreItem.current && !loading && getMoreItemRef.current) {
            scrollPositionRef.current = scrollTop;
            getMoreItemRef.current();
          }
        }, 600);
      } else {
        const hasMoreItems = isGetMoreItem.current && !loading;
        setShowScrollIndicator(hasMoreItems && scrollHeight > clientHeight);
      }
    };

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = null;
      }
      listenerAddedRef.current = false;
    };
  }, [loading]);

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    setSearchTerm("");
    setProductsDetailData([]);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    setCount(0);
    isGetMoreItem.current = true;
    scrollPositionRef.current = 0;
    setShowScrollIndicator(false);

    setProductsBrandTemp(null);
    setProductsCategoryTemp(null);
    setProductsCategorySubTemp(null);

    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
    }
    listenerAddedRef.current = false;

    props.handleCloseMediaInteraction(false);
  }

  function handleSelectBrand() {
    setLoading(true);
    setCount(0);
    isGetMoreItem.current = true;
    scrollPositionRef.current = 0;
    setShowScrollIndicator(false);
    if (productsBrandTemp) {
      const updatedPayload = {
        ...payloadShopSite,
        term: searchTerm,
        brandId: productsBrandTemp?.brandId,
        categoryId: "",
        start: 0,
      };
      getItemTranontService(updatedPayload, shopSiteName)
        .then((resp: any) => {
          const inner = resp.data;
          dispatch(
            setShopComAllData({
              ...inner,
              searchTerm: updatedPayload.term,
            })
          );
          setProductsCategoryTotal(inner["categories"]);
          setProductsBrandTotal(getTrademarkOutput(inner["brands"]));
          setProductsCategorySub("Select Sub Categories");
          setLoading(false);
        })
        .catch((err) => {
          console.log("API shop COM error:", err);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }

  function handleSelectCategory() {
    setLoading(true);
    setCount(0);
    isGetMoreItem.current = true;
    scrollPositionRef.current = 0;
    setShowScrollIndicator(false);
    if (productsCategoryTemp) {
      const updatedPayload = {
        ...payloadShopSite,
        brandId: productsBrandTemp?.brandId,
        categoryId: productsCategoryTemp?.categoryId,
        term: searchTerm,
        start: 0,
      };
      getItemTranontService(updatedPayload, shopSiteName)
        .then((resp: any) => {
          const inner = resp.data;
          setProductsCategorySub(inner["categories"]);
          dispatch(
            setShopComAllData({
              ...inner,
              searchTerm: updatedPayload.term,
            })
          );
          setLoading(false);
        })
        .catch((err) => {
          console.log("API shop COM error:", err);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }

  function handleSelectCategorySub() {
    setLoading(true);
    setCount(0);
    isGetMoreItem.current = true;
    scrollPositionRef.current = 0;
    setShowScrollIndicator(false);
    if (productsCategorySubTemp && productsBrandTemp) {
      const updatedPayload = {
        ...payloadShopSite,
        brandId: productsBrandTemp?.brandId,
        categoryId: productsCategorySubTemp?.categoryId,
        term: searchTerm,
        start: 0,
      };
      getItemTranontService(updatedPayload, shopSiteName)
        .then((resp: any) => {
          const inner = resp.data;
          dispatch(
            setShopComAllData({
              ...inner,
              searchTerm: updatedPayload.term,
            })
          );
          setLoading(false);
        })
        .catch((err) => {
          console.log("API shop COM error:", err);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }

  function handleSelectItem(items: any) {
    const isSelected = selectedItems?.includes(items);

    if (isSelected) {
      setSelectedItems(
        selectedItems.filter((selectedItem: any) => selectedItem !== items)
      );
    } else {
      if (!checkElementPresentInArray(items?.id)) {
        setSelectedItems([...selectedItems, items]);
      } else {
        toast(`${items.name} ${language["already_in_interactions"]}.`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
  }

  function checkShopSite(site: any) {
    const locale = publicUserData?.locale;
    const initialPayload = {
      ...payloadTranontSite,
      locale: locale,
      start: 0,
    };
    return setPayloadShopSite(initialPayload);
  }

  function checkShopSiteTitle(siteName: any, company_name: any) {
    switch (siteName) {
      case "nfr": {
        return <span style={{ fontSize: "1.75rem" }}>NFR Market (USD)</span>;
      }
      case "otg": {
        return <span style={{ fontSize: "1.75rem" }}>OTG Market (CAD)</span>;
      }

      default:
        return (
          <img
            src={tranont_brand}
            alt="Icon"
            height={150}
            width={150}
            style={{
              backgroundColor: "white",
              padding: 20,
              borderRadius: 10,
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            }}
          />
        );
    }
  }

  const getMoreItem = useCallback(() => {
    if (loading || !isGetMoreItem.current) {
      return;
    }

    setCount((prevCount: any) => {
      const newCount = prevCount + 20;
      const currentSearchTerm = inputRef.current?.value || "";

      if (newCount >= totalItems.current) {
        isGetMoreItem.current = false;
      }

      setPayloadShopSite((prevPayload: any) => ({
        ...prevPayload,
        start: newCount,
        term: currentSearchTerm,
        brandId: productsBrandTemp?.brandId ?? prevPayload?.brandId,
        categoryId:
          productsCategorySubTemp?.categoryId ??
          productsCategoryTemp?.categoryId ??
          prevPayload?.categoryId ??
          "",
      }));

      return newCount;
    });
  }, [
    loading,
    productsBrandTemp,
    productsCategorySubTemp,
    productsCategoryTemp,
  ]);

  useEffect(() => {
    getMoreItemRef.current = getMoreItem;
  }, [getMoreItem]);

  useEffect(() => {
    const isInitialLoad =
      count === 0 || !payloadShopSite?.start || payloadShopSite.start === 0;

    if (
      isInitialLoad &&
      shopComAllData["products"] &&
      !isMergingProductsRef.current
    ) {
      const uniqueProductIds = new Set();
      const uniqueProducts = shopComAllData["products"].filter(
        (product: any) => {
          if (!uniqueProductIds.has(product.id)) {
            uniqueProductIds.add(product.id);
            return true;
          }
          return false;
        }
      );
      setProductsDetailData(uniqueProducts);
    }

    if (
      count > 0 &&
      scrollPositionRef.current > 0 &&
      listContainerRef.current &&
      !isMergingProductsRef.current
    ) {
      const savedScrollPosition = scrollPositionRef.current;
      setTimeout(() => {
        if (listContainerRef.current) {
          const currentScrollHeight = listContainerRef.current.scrollHeight;
          const scrollPosition = Math.min(
            savedScrollPosition,
            currentScrollHeight - listContainerRef.current.clientHeight
          );
          listContainerRef.current.scrollTop = scrollPosition;
        }
      }, 50);
    }
  }, [shopComAllData, count, payloadShopSite]);

  useEffect(() => {
    if (
      listContainerRef.current &&
      productsDetailData.length > 0 &&
      !loading
    ) {
      const container = listContainerRef.current;
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 50;

      if (!isNearBottom && isGetMoreItem.current && scrollHeight > clientHeight) {
        setShowScrollIndicator(true);
      } else {
        setShowScrollIndicator(false);
      }
    } else {
      setShowScrollIndicator(false);
    }
  }, [productsDetailData, loading]);

  useEffect(() => {
    if (productsBrandTemp !== null) {
      setProductsDetailData([]);
      handleSelectBrand();
    }
  }, [productsBrandTemp]);

  useEffect(() => {
    if (productsCategoryTemp !== null) {
      setProductsDetailData([]);
      handleSelectCategory();
    }
  }, [productsCategoryTemp]);

  useEffect(() => {
    if (productsCategorySubTemp !== null) {
      setProductsDetailData([]);
      handleSelectCategorySub();
    }
  }, [productsCategorySubTemp]);

  const debouncedSearch = useCallback(
    debounce((term: string) => {
      setProductsDetailData([]);
      setCount(0);
      isGetMoreItem.current = true;
      scrollPositionRef.current = 0;
      setShowScrollIndicator(false);

      setPayloadShopSite((prev: any) => ({
        ...prev,
        term,
        start: 0,
        brandId: productsBrandTemp?.brandId,
        categoryId:
          productsCategorySubTemp?.categoryId ??
          productsCategoryTemp?.categoryId ??
          "",
      }));
    }, 300),
    [productsBrandTemp, productsCategorySubTemp, productsCategoryTemp]
  );

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchTerm = event.target.value;
    setSearchTerm(newSearchTerm);
    setCount(0);
    debouncedSearch(newSearchTerm);
  };

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const addInteractionDataToArray = (item: any) => {
    selectedItems.forEach((item: any) => {
      var resp = createStreamData;
      if (
        resp &&
        resp["metadata"] &&
        resp["metadata"]["attendees"] &&
        resp["metadata"]["attendees"].filter(
          (p: { role: string }) => p.role == "host"
        )
      ) {
        var hostInfo = resp["metadata"]["attendees"].filter(
          (p: { role: string }) => p.role == "host"
        )[0];
        callEvent([
          {
            event_data: {
              attendee_email: hostInfo["email"],
              attendee_first: hostInfo["given_name"],
              attendee_id: hostInfo["attendee_id"],
              attendee_role: "attendee",
              attendee_last: hostInfo["family_name"] + " (host)",
              client_id: hostInfo.attendee_id.split("|")[0],
              stream_id: joinWithAttendeeData["stream_id"],
              stream_instance_id: resp["stream_instance_id"],
              user_id: hostInfo.attendee_id.split("|")[1],
              interaction_id: item?.id,
              interaction_type: "media",
              interaction_label: item?.name,
              interaction_action: item?.shopUrl,
              interaction_imageUrl: item?.imageUrl,
              elapsed_seconds: hostTime,
              date: new Date().toUTCString(),
            },
            event_type: "interaction_created",
          },
        ]);
      }
      setInteractionDataArray((prevArray) => [
        ...prevArray,
        {
          attributes: {
            action: item?.shopUrl,
            label: item?.name,
            isLinkedToStore: false,
            assetId: `${item?.opContainerId}`,
            description: item?.description,
            price:
              item?.maximumPrice != null && item?.minimumPrice != null
                ? item?.maximumPrice === item?.minimumPrice
                  ? item?.minimumPriceString
                  : `${item?.minimumPriceString}-${item?.maximumPriceString}`
                : item?.minimumPriceString || item?.maximumPriceString || "",
            createdOn: `${time}`,
            isDefault: false,
            eCommerce: false,
            shouldShow: true,
            labelVisible: true,
            thirdPartyUsername: "",
            locale: publicUserData?.locale,
            isProduct: true,
            productMaxPrice: item?.maximumPrice,
            productMinPrice: item?.minimumPrice,
            opContainerId: item?.opContainerId,
            zyiaSymbolSuffix: "",
            siteName: siteName,
            hostUserName: "",
            isMAShop: true,
            rotatable: true,
            draggable: true,
            scalable: true,
            deletable: true,
            editable: true,
            iframeable: true,
            maximumPriceString: item?.maximumPrice,
            minimumPriceString: item?.minimumPrice,
            nfr: item?.metadata?.nfr,
          },
          style: {
            style_type: "photo",
            pulse_animation: false,
            opacity: 1,
            thumbnail_url: item?.imageUrl,
          },
          center_x: 50,
          center_y: 50,
          rotation_angle: 0,
          start: 0,
          end: 5,
          height_max: 100,
          height_pc: 17,
          interaction_id: `${item?.opContainerId}`,
          interaction_subtype: "other",
          interaction_type: "media",
          width_max: 100,
          width_pc: 8,
          featured: false,
        },
      ]);
    });

    setSelectedItems([]);

    setTimeout(() => {
      props.handleCloseMediaInteraction(true);
    }, 200);
  };

  const checkElementPresentInArray = (id: any) => {
    return interactionDataArray.some(
      (element: any) => element.interaction_id == id
    );
  };

  function getTrademarkSymbol(trademark: any) {
    if (trademark?.includes("&reg;")) {
      return "®";
    } else if (trademark?.includes("&trade;")) {
      return "™";
    } else {
      return "";
    }
  }
  function removeHtmlEntities(str: any) {
    return str.replace(/&[^;]+;/g, "");
  }

  function getTrademarkOutput(trademarks: any) {
    return trademarks?.map((trademark: any) => {
      return {
        brandId: trademark.brandId,
        brandName:
          removeHtmlEntities(trademark.brandName) +
          getTrademarkSymbol(trademark.brandName),
      };
    });
  }

  const formatPriceRange = (
    minimumPrice: string | number | undefined,
    maximumPrice: string | number | undefined,
    shopSiteName: string | undefined
  ) => {
    // Handle undefined or null cases
    if (!minimumPrice && !maximumPrice) return "";

    // Convert to strings and clean any existing currency symbols
    const cleanMinPrice = String(minimumPrice || "")
      .replace(/^[£$€¥]/, "")
      .trim();
    const cleanMaxPrice = String(maximumPrice || "")
      .replace(/^[£$€¥]/, "")
      .trim();

    // Determine currency prefix and suffix based on shop site
    const currencyPrefix = "$";
    const currencySuffix = shopSiteName?.toLowerCase().includes("nfr")
      ? " USD"
      : shopSiteName?.toLowerCase().includes("otg")
      ? " CAD"
      : "";

    // If prices are the same or only one price exists, return single price
    if (!cleanMaxPrice || cleanMinPrice === cleanMaxPrice) {
      return `${currencyPrefix}${cleanMinPrice}${currencySuffix}`;
    }

    // Return price range
    return `${currencyPrefix}${cleanMinPrice} - ${currencyPrefix}${cleanMaxPrice}${currencySuffix}`;
  };

  return (
    <Modal
      isOpen={props.modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="flex w-full h-full bg-neutral-800 " id={"ModalInner"}>
        <div className="flex flex-col w-full bg-black  rounded-lg p-4">
          <span className="text-white text-4xl font-medium p-2">
            {checkShopSiteTitle(shopSiteName, publicUserData?.company_name)}
          </span>
          <div className="w-full bg-white h-0.5 m-2" />
          <div>
            <span className="text-white p-2">
              {language["select_products_prompt"]}
            </span>
          </div>
          <div className="flex flex-row my-4 w-full" style={{ zIndex: 1 }}>
            {productsBrandTotal && productsBrandTotal.length > 0 && (
              <div>
                <SelectListBrand
                  defaultSelectedItem={{
                    brandId: "all",
                    brandName: language["select_brand"],
                  }}
                  data={productsBrandTotal}
                  onSelect={(item: any) => {
                    setProductsBrandTemp(item);
                  }}
                  ref={childeBrandRef}
                  onCloseOtherList={() => {
                    childeCatRef?.current?.handleCloseListDisplay();
                    childeSubCatRef?.current?.handleCloseListDisplay();
                  }}
                />
              </div>
            )}
            {productsCategoryTotal && productsCategoryTotal.length > 0 && (
              <div className="ml-10">
                <SelectListCategories
                  defaultSelectedItem={language["select_categories"]}
                  data={productsCategoryTotal}
                  onSelect={(item: any) => {
                    setProductsCategoryTemp(item);
                  }}
                  ref={childeCatRef}
                  onCloseOtherList={() => {
                    childeBrandRef?.current?.handleCloseListDisplay();
                    childeSubCatRef?.current?.handleCloseListDisplay();
                  }}
                />
              </div>
            )}

            {productsCategorySub && productsCategorySub.length > 0 && (
              <div className="ml-10">
                <SelectListCategoriesSub
                  defaultSelectedItem={language["select_sub_categories"]}
                  data={productsCategorySub}
                  onSelect={(item: any) => {
                    setProductsCategorySubTemp(item);
                  }}
                  ref={childeSubCatRef}
                  onCloseOtherList={() => {
                    childeBrandRef?.current?.handleCloseListDisplay();
                    childeCatRef?.current?.handleCloseListDisplay();
                  }}
                />
              </div>
            )}

            <div className="flex flex-row border-2 border-zinc-700 rounded-lg ml-2 p-2 items-center justify-center search-container">
              <BiSearch fill="white" size="24" />
              <input
                className="bg-black w-52 text-white pl-2 outline-none placeholder:text-white"
                placeholder={language["search_label"]}
                onChange={handleSearch}
                ref={inputRef}
              />
            </div>

            <div className="items-center absolute right-4 top-3 ">
              <TfiClose
                onClick={closeModal}
                color="#DEDEDE"
                size={30}
                cursor="pointer"
              />
            </div>
          </div>
          {/* overflow-y-scroll no-scrollbar */}
          <div
            id="list-container"
            ref={listContainerRef}
            className="h-full w-full overflow-y-scroll containerModal relative"
          >
            {loading ? (
              <div className="flex justify-center items-center h-full">
                <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-white"></div>
              </div>
            ) : productsDetailData &&
              productsDetailData.length == 0 &&
              isDataFetched ? (
              <NoResult></NoResult>
            ) : (
              <>
                <div className="grid grid-cols-6 gap-2 ">
                  {productsDetailData?.map((item: any, index) => {
                    const isSelected = selectedItems.includes(item);

                    return (
                      <div
                        className={`flex flex-col p-2 ${
                          isSelected ? "selected-item" : ""
                        }`}
                        key={`${item?.id}-${index}`}
                        onClick={() => handleSelectItem(item)}
                      >
                        <div className="rounded-lg inset-0 w-full h-44 bg-zinc-300">
                          {isSelected && (
                            <div
                              className={`selected-indicator`}
                              style={{
                                backgroundColor: `${
                                  getBrandTheme(client).primary
                                } `,
                              }}
                            />
                          )}

                          <img
                            className="h-full w-full object-cover object-center rounded-lg"
                            src={`${item?.imageUrl}`}
                            onError={(event) => {
                              event.currentTarget.src =
                                "https://andersnoren.se/themes/koji/wp-content/themes/koji/assets/images/default-fallback-image.png";
                            }}
                            alt=""
                          />
                        </div>
                        <div className="text-white mt-2 line-clamp-2">
                          <div
                            dangerouslySetInnerHTML={{ __html: item?.name }}
                          />
                          {/* {item?.name} */}
                        </div>
                        {/* <div className="text-white mt-2 line-clamp-2">
                        {item?.description}
                      </div> */}
                        <div className="text-white mt-2 line-clamp-2 text-base font-medium">
                          {item.maximumPriceString
                            ? formatPriceRange(
                                item?.minimumPriceString,
                                item?.maximumPriceString,
                                shopSiteName
                              )
                            : formatPriceRange(
                                item?.minimumPriceString,
                                item?.maximumPriceString,
                                shopSiteName
                              )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {showScrollIndicator && (
                  <div className="fixed bottom-8 right-8 z-40 pointer-events-none">
                    <div
                      className="flex flex-col items-center justify-center rounded-full p-2 shadow-lg opacity-70"
                      style={{
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        border: `1px solid ${getBrandTheme(client).primary}`,
                      }}
                    >
                      <div className="flex flex-col items-center gap-0">
                        <MdKeyboardArrowDown
                          className="text-white text-2xl animate-bounce"
                          style={{ animationDelay: "0s" }}
                        />
                        <MdKeyboardArrowDown
                          className="text-white text-2xl animate-bounce -mt-2"
                          style={{ animationDelay: "0.1s" }}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {selectedItems.length > 0 && (
                  <div
                    className={`h-12 w-64 flex items-center justify-center rounded-lg ml-[40%] cursor-pointer fixed bottom-8`}
                    onClick={() => {
                      addInteractionDataToArray(selectedItems);
                    }}
                    style={{
                      backgroundColor: `${getBrandTheme(client).primary} `,
                    }}
                  >
                    <span className="text-white text-2xl">
                      {language["add_button"]}
                    </span>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default InteractionTranont;
